import { render, staticRenderFns } from "./Import.vue?vue&type=template&id=3fc623d5&scoped=true"
import script from "./Import.vue?vue&type=script&lang=js"
export * from "./Import.vue?vue&type=script&lang=js"
import style0 from "./Import.vue?vue&type=style&index=0&id=3fc623d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc623d5",
  null
  
)

export default component.exports